import React, { useState } from "react";
import { Box, Grid, makeStyles, Paper } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Helmet } from "react-helmet";

import AppConfig from "../../config/AppConfig";
import { forgotPassword } from "store/slices/auth";
import AppNavbarLayout from "../../components/Navbars/AppNavbarLayout";
import styles from "assets/jss/material-dashboard-react/components/headerStyle.js";
import AppButton from "../../components/CustomButtons/AppButton";
import AppColor from "../../utilities/AppColor";
import ForgotPasswordForm from "./Form/ForgotPasswordForm";
import SuccessPage from "./Component/SuccessPage";
import LogoIcon from "assets/icons/care-aid.png";

const useStyles = makeStyles((theme) => ({
  ...styles(theme),
  appBar: {
    ...styles(theme).appBar,
    color: "#555555",
  },
  logoTitle: {
    height: 40,
    '& img': {
      maxHeight: 40
    }
  },
  title: {
    color: AppColor.black,
    fontSize: '24px',
    fontWeight: '500',
    textAlign: 'center'
  },
  description: {
    color: AppColor.black,
    fontSize: '14px',
    textAlign: 'center',
    fontWeight: '500'
  },
  logo: {
    display: 'flex',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  menuContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  paper: {
    padding: "30px",
    borderRadius: 10,
  },
  signup: {
    color: AppColor.mainColor,
    textTransform: "unset",
    fontSize: 14,
    fontWeight: '600',
    whiteSpace: 'nowrap',
    paddingLeft: '0.25rem',
    cursor: 'pointer'
  },
  generalText: {
    fontSize: 14,
    color: AppColor.black
  },
  margin: {
    marginTop: theme.spacing(2),
    padding: '1px 6px'
  },
  button: {
    backgroundColor: AppColor.white,
    fontSize: 14,
    fontWeight: "500",
    borderRadius: '50px',
    textTransform: "none",
    "& .MuiButton-label": {
      justifyContent: "space-between",
    },
  },
  dividerTextContainer: {
    marginTop: '-16px',
    color: AppColor.black,
    display: 'flex',
    justifyContent: 'center'
  },
  dividerText: {
    width: 'fit-content',
    backgroundColor: '#f9f7f6',
    paddingRight: '5px',
    paddingLeft: '5px'
  },
  marginVertical: {
    marginTop: '100px',
    marginBottom: '100px'
  }
}));

export default function Login() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const hostname = window.location.hostname;
  // const listDomainSuperAdmin = process.env.REACT_APP_DOMAIN_SUPER_ADMIN.split(',');

  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  // const [companyList, setCompanyList] = useState([]);
  // const [emailSelected, setEmailSelected] = useState("");
  const _navigateToLogin = () => {
    history.push(`/auth/${_getType()}/login`);
  }

  const _getLoginType = () => {
    return history.location.pathname.includes('client')
      ? AppConfig.LOGIN_TYPES.CLIENT
      : history.location.pathname.includes('worker')
        ? AppConfig.LOGIN_TYPES.WORKER
        :history.location.pathname.includes('company')
        ? AppConfig.LOGIN_TYPES.COMPANY 
        : AppConfig.LOGIN_TYPES.ADMIN;
  }

  const _getType = () => {
    return history.location.pathname.includes('client')
      ? 'client'
      : history.location.pathname.includes('worker')
        ? 'worker'
        : history.location.pathname.includes('company') 
          ? 'company'
          : 'admin';
  }

  const submit = async (data) => {
    const request = {
      email: data.email.trim(),
      domain: hostname,
      loginType: _getLoginType()
    };
    // if (_getLoginType() === AppConfig.LOGIN_TYPES.WORKER || _getLoginType() === AppConfig.LOGIN_TYPES.CLIENT) {
    //   request['companyId'] = data.companyId;
    // }
    setLoading(true);
    const { payload } = await dispatch(forgotPassword(request));
    setLoading(false);
    if (payload) {
      setShowSuccess(true);
    }
  };

  // const handleSubmitEmail = async (data) => {
  //   setLoading(true);
  //   const request = {
  //     email: data.email.trim(),
  //     type: _getLoginType(),
  //   };

  //   const result = await dispatch(fetchAccountList(request));
  //   setLoading(false);
  //   if (result.payload) {
  //     setCompanyList(result.payload);
  //     setEmailSelected(data.email.trim());
  //     // setIsNextStep(true);
  //   }
  // };

  return (
    <div style={{ width: '100%' }}>
      <Helmet>
        <title>{t('label.resetPassword')}</title>
      </Helmet>
      <AppNavbarLayout>
      <div className={classes.flex}>
          <Box className={classes.logoTitle}>
            <img src={LogoIcon}/>
          </Box>
        </div>
        <div className={classes.menuContainer}>
          <AppButton
            label={`${t("button.sign_in")}`}
            onClick={_navigateToLogin}
            style={{
              whiteSpace: 'nowrap'
            }}
          />
        </div>
      </AppNavbarLayout>
      {
        showSuccess
          ? (
            <SuccessPage
              messageSuccess="text.forgotPasswordSuccess"
              labelButton="button.ok"
              onConfirm={_navigateToLogin}
            />
          )
          : (
            <div className={`container-fluid ${classes.marginVertical}`}>
              <div style={{ marginBottom: '25px' }}>
                <h5 className={classes.title}>{t('label.resetPassword')}</h5>
                <h5 className={classes.description}>{t('text.resetPassword')}</h5>
              </div>
              <Grid container justifyContent="center">
                <Grid item xs={12} sm={6} md={4}>
                  <Paper className={classes.paper} elevation={5}>
                    <ForgotPasswordForm onSubmit={submit} loading={loading}/>
                  </Paper>
                  {(_getLoginType() === AppConfig.LOGIN_TYPES.WORKER || _getLoginType() ===  AppConfig.LOGIN_TYPES.CLIENT) && (
                  <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="baseline"
                  mt={3}
                  mb={2}
                >
                  <p className={classes.generalText}>
                    {t("text.do_not_your_account")}
                  </p>
                  <div
                    className={classes.signup}
                    onClick={() => _navigateToLogin()}
                  >
                    {t("label.return_to_login")}
                  </div>
                </Box>
                )}
                  {/* {history.location.pathname.includes('company') && !(listDomainSuperAdmin.indexOf(hostname) <= -1) &&              
                  <Box display="flex" justifyContent="center" alignItems="baseline" mt={3} mb={2}>
                    <p className={classes.generalText}>{t('text.no_care_aid_account')}</p>
                    <div
                      className={classes.signup}
                      onClick={() => history.location.pathname.includes('company')  ? history.push('/auth/signup',{signupType: 'company'}): history.push('/auth/signup')}
                    >
                      {t('label.sign_up_here')}
                    </div>
                  </Box>} */}
                </Grid>
              </Grid>
            </div>
          )
      }
    </div>
  );
}
